window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.c-room-booking').forEach(initRoomBookingForm);
});

/**
 * Initializes the room "booking" form (redirecting to the booking page).
 * @param {HTMLFormElement} form - The form element to initialize.
 */
function initRoomBookingForm(form) {
  const arrival = form.querySelector('.c-start-date');
  const departure = form.querySelector('.c-end-date');
  if (!arrival || !departure) return;
  initArrivalAndDeparture(arrival, departure);
}

/**
 * Initializes the arrival and departure date fields.
 * @param {HTMLInputElement} arrival - The arrival date input element.
 * @param {HTMLInputElement} departure - The departure date input element.
 */
function initArrivalAndDeparture(arrival, departure) {
  // Add a listener to the arrival date field
  arrival.addEventListener('change', () => {
    let nextDayDate = new Date(arrival.valueAsDate);
    nextDayDate.setDate(nextDayDate.getDate() + 1);
    departure.min = new Date(nextDayDate.getTime() - (nextDayDate.getTimezoneOffset() * 60000)).toISOString().split("T")[0];

    // Update the departure date field if necessary
    if (departure.valueAsDate < arrival.valueAsDate) {
      departure.valueAsDate = nextDayDate;
    }
  });

  // Add a listener to the departure date field
  departure.addEventListener('change', () => {
    // Update the arrival date field if necessary
    if (arrival > departure) {
      arrival.value = departure.value;
    }
  });
}
